export const environment = {
  production: true,
  buildId: '3082949096420341',
  configFile: 'config.json',
};
